function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6,28 C11.4951172,33.4033203 17.4313151,36.1049805 23.8085938,36.1049805 C30.1858724,36.1049805 36.0670573,33.4033203 41.4521484,28"
}), React.createElement("path", {
  stroke: "currentColor",
  d: "M41.3553323,22 C36.1382895,15.6534923 30.3597307,12.5 24,12.5 C17.6402693,12.5 11.8617105,15.6534923 6.64466771,22 C11.8617105,28.3465077 17.6402693,31.5 24,31.5 C30.3597307,31.5 36.1382895,28.3465077 41.3553323,22 Z M24,29.5 C19.8578644,29.5 16.5,26.1421356 16.5,22 C16.5,17.8578644 19.8578644,14.5 24,14.5 C28.1421356,14.5 31.5,17.8578644 31.5,22 C31.5,26.1421356 28.1421356,29.5 24,29.5 Z"
}));

var SvgEyebags = function SvgEyebags(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyebags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyebags.4870ec57.svg";
export { ForwardRef as ReactComponent };